export default "__VITE_ASSET__766vnt2N__"